import styled from 'styled-components';

export const SettingsTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DateInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const CustomDatePickerContainer = styled.div`
  width: 100%;
  div {
    width: 100% !important;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;
